<template>
  <div v-if="canPrint">
    <BaseButton
      type="button"
      :disabled="disabled"
      :size="size"
      @click="onRePrintSppb"
    >
      <Icon icon="heroicons:printer-solid" class="h-4 w-4" />
      Cetak SPPB
    </BaseButton>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :preview-modal="true"
      :enable-download="true"
      :paginate-elements-by-height="5000"
      :filename="filename"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="210mm"
      ref="html2Pdf"
    >
      <PdfContent slot="pdf-content" :label="label" :order="order" />
    </VueHtml2pdf>
    <Loading v-if="loadingDisableInvoice || loadingOrder" />
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import PdfContent from '@/layouts/LayoutPrintA4.vue';
import { requestMixin } from '../../mixins/request/request.js'
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  components: { VueHtml2pdf, PdfContent },
  props: {
    orderId: String,
    method: {
      type: String,
      default: 'load'
    },
    size: {
      type: String,
      default: 'md'
    },
    label: String
  },
  emits: ['status-updated'],
  data() {
    return {
      loadingDisableInvoice: false,
      loadingOrder: false,
      order: {
        data: {
          attributes: {},
          relationships: {
            'destination-office': {
              data: null,
            },
            village: {
              data: null,
            },
            district: {
              data: null,
            },
            city: {
              data: null,
            },
            province: {
              data: null,
            },
          },
        },
        included: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      checkHasPermission: 'auth/checkHasPermission',
    }),
    disabled() {
      if (this.method === 'click') {
        return false
      }

      return this.getIncludedByType(this.order, 'order-details')
        .every(orderDetail => orderDetail.attributes.product_shipped_qty === orderDetail.attributes.product_qty)
    },
    filename() {
      const datetime = dayjs(this.order.data.attributes.createdAt).format('YYYYMMDD')
      const type = 'sppb'
      const code = `${this.order.data.attributes.origin_code}_${this.order.data.attributes.destination_code}`
      const user = this.me.office_code

      return [datetime, type, code, user].join('-')
    },
    canPrint() {
      if (this.originOfficeType !== 'pusat') {
        return true
      }

      return this.checkHasPermission('orders.read_persiapan')
    }
  },
  methods: {
    async onRePrintSppb() {
      this.loadingDisableInvoice = true;

      if (this.method === 'click'){
        await this.updateStatus()
        await this.loadOrder()
      }

      const [, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/print-sppb`,
        {
          method: 'patch',
        }
      );

      if (!err) {
        setTimeout(() => {
          this.$refs.html2Pdf.generatePdf();
        }, 0);

        const waitForEl = setInterval(() => {
          const el = document.querySelector(
            'div.vue-html2pdf > section.pdf-preview > button'
          );

          if (el) {
            el.onclick = () => {
              if (this.method === 'click') {
                this.$emit('status-updated')
              }
            };
            clearInterval(waitForEl);
          }
        }, 100);
      }

      this.loadingDisableInvoice = false;
    },
    async loadOrder() {
      this.loadingOrder = true;

      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}`,
        {
          params: {
            include:
              'destination-office,village,district,city,province,order-details,order-detail-bonuses,origin-office,destination-warehouse',
            'fields[orders]':
              'receipt_name,receipt_phone,complete_shipment_address,prepared,warehouse_status,sppb_print_count,origin_code,reference_code,createdAt,orderedAt,destination-office,order_shipment,shipment_address,village,district,city,province,order-details,order-detail-bonuses,print_invoice_enabled,origin-office,area_name,area_code,notes,destination-warehouse,grand_total_price,shipping_fee,plastic_qty',
            'fields[offices]':
              'code,name,full_address,phone,office_type,address_details,kta',
            'fields[villages]': 'name',
            'fields[districts]': 'name',
            'fields[cities]': 'name',
            'fields[provinces]': 'name',
            'fields[order-details]':
              'product_code,product_name,product_shipped_qty,product_qty,product_price,total_price,bonus_value,product_not_packed',
            'fields[order-detail-bonuses]':
              'product_code,product_name,bonus_qty',
            'fields[warehouses]': 'code',
          },
        }
      );

      if (!err) {
        this.order = res;

        localStorage.removeItem('print_sppb_page')
      }

      this.loadingOrder = false;
    },
    async updateStatus() {
      await this.request(
        `/api/v1/orders/${this.orderId}`,
        {
          method: 'patch',
          data: {
            data: {
              type: 'orders',
              id: this.orderId,
              attributes: {
                print_invoice_enabled: false
              }
            }
          }
        }
      );
    }
  },
  created() {
    if (this.method === 'load'){
      this.loadOrder()
    }
  }
}
</script>
